export default "__VITE_ASSET__Bw4kxMwC__$_?url__"